import React from 'react';
import createClass from 'create-react-class';
import { withTranslation } from 'react-i18next';

import ProfileStore from '../../../stores/ProfileStore';
import SearchStore from '../../../stores/SearchStore';

function getPrivateTravelState() {
	return {
		private_travel_company: ProfileStore.isPrivateTravel(),
		private_travel_search: SearchStore.isPrivateTravel(),
	};
}

var PrivateTravelComponent = createClass({
	displayName: 'PrivateTravelComponent',

	getInitialState: function () {
		return getPrivateTravelState();
	},

	_onChange: function (event, value) {
		this.setState(getPrivateTravelState());
	},

	render: function () {
		const { t } = this.props;
		return (
			<div className="private-travel-component">
				<span>{t('LeisureTravelPolicyNotApply')}</span>
			</div>
		);
	},
});

export default withTranslation()(PrivateTravelComponent);
